import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import groupBy from 'lodash/groupBy';
import moment from 'moment-timezone';

import LiveWebinarItem from './LiveWebinarItem';
import {
  WEBINAR_LIST_WIDTH,
  BREAKPOINT,
} from './constants';

const RootContainer = styled.div`
  position: relative;
  flex: 1 0 auto;
  max-width: ${WEBINAR_LIST_WIDTH}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;

  @media (min-width: 960px) {
    padding: 28px 0;
  }

  @media (max-width: 960px) {
    padding: 16px 0;
  }
`;

const locale = 'en';
const LiveWebinarList = ({ webinars }) => {
  const webinarsByTime = groupBy(
    webinars,
    ({ startAt, timezone }) => {
      const startDatetime = moment.tz(startAt, timezone);
      const minutes = startDatetime.minutes() >= 30 ? '30' : '00';

      return `${startDatetime.format('h')}:${minutes}${startDatetime.format('A')}`;
    },
  );
  return (
    <RootContainer>
      {
        Object.keys(webinarsByTime).map((timeStr) => {
          const items = webinarsByTime[timeStr];
          return items.map(({
            id, startAt, endAt, timezone, speakers, translations,
          }) => (
            <LiveWebinarItem
              key={id}
              id={id}
              name={translations[locale].title}
              startAt={startAt}
              endAt={endAt}
              timezone={timezone}
              details={translations[locale].description}
              url={translations[locale].url}
              cfStreamId={translations[locale].cloudflare_stream_id}
              speakers={speakers}
              showTimelineIndicator={false}
              timelineIndicatorText={timeStr}
            />
          ));
        })
      }
    </RootContainer>
  );
};

LiveWebinarList.propTypes = {
  webinars: PropTypes.arrayOf(PropTypes.shape()),
};

LiveWebinarList.defaultProps = {
  webinars: [],
};

export default LiveWebinarList;
